import React, { useState } from "react";

const useToggle = (defaultValue) => {
  const [show, setShow] = useState(defaultValue ? defaultValue : false);

  const toggle = () => {
    setShow(!show);
  };

  return {
    show,
    setShow,
    toggle,
  };
};

export default useToggle;
